;(function() {
/* @ngInject */
function ZalozenieOZObjednaneController(CompletedOrderService, $window, $filter, ModalInfo, Helpers) {
  let vm = this;
  let server = CompletedOrderService;

  vm.generateDocs = generateDocs;
  vm.getFileName = Helpers.getFileName;
  vm.payment = "movement";
  vm.showMovement = false;
  vm.isUnzipFiles = true;
  vm.showLoading = false;
  vm.downloadLabel = $filter("translate")('payments.documents.general');

  server.getCompletedOrderData().then(onPaymentInfoLoad);

  let dataLayerStorage = $window.localStorage.getItem('dataLayer');
  $window.localStorage.removeItem('dataLayer');
  var dataLayer = $window.dataLayer = $window.dataLayer || [];
  if (dataLayerStorage)
    dataLayer.push(JSON.parse(dataLayerStorage));

  function onPaymentInfoLoad(payment) {
    if(payment) {
      vm.orderId = payment.orderId;
      vm.price = payment.price;
      vm.paymentData = payment;
      vm.invoiceHref = `/invoice/download?orderId=${payment.orderId}`;
      vm.proformaHref = `/invoice/download?proforma=true&orderId=${payment.orderId}`;
      vm.documentsHref = `/objednavka/detail?o=${payment.documentsLink}`;

      if(Date.now() < new Date("2021-03-01") && payment.price !== payment.paidAmount)
        ModalInfo("zalozenieOZ.actualInfoTitle", "zalozenieOZ.actualInfoText", "buttons.understand")
            .add()
            .result
            .then();
    } else {
      $window.location = "krok1";
    }
  }

  function generateDocs(isPdf) {
    vm.showLoading = true;
    server.regenerateDocs().then(() => {
      server.getCompletedOrderData().then((p) => {
        if(p.documentsLink) {
          let url = '/objednavka' + (isPdf ? '' : '-uss') + '/detail?o=' + p.documentsLink;
          $window.location = url;
        }
      });
      vm.showLoading = false;
    });
  }
}

angular.module("firmaren")
  .controller("ZalozenieOZObjednaneController", ZalozenieOZObjednaneController);
}());
